import { LegacyProductCode } from '@up2stay/up2promo-api-client';

import { ProductTypeIcon } from '@/core/components/products/product-type-icon';
import { useDictionary } from '@/core/providers/dictionary-provider';
import { selectableSetupTypes } from '@/routes/app/products-setup-wizard/products-setup-configure-flow';
import { ProductsSetupChoiceCard } from '@/routes/app/products-setup-wizard/products-setup-choice-card';
import { ProductsSetupStepShell } from '@/routes/app/products-setup-wizard/products-setup-step-shell';

const TYPE_LABEL_KEYS: Record<LegacyProductCode, string> = {
  [LegacyProductCode.GO]: 'typeGo',
  [LegacyProductCode.IG]: 'typeIg',
  [LegacyProductCode.TT]: 'typeTt',
  [LegacyProductCode.FB]: 'typeFb',
  [LegacyProductCode.ME]: 'typeMe',
  [LegacyProductCode.CU]: 'typeCu',
  [LegacyProductCode.BC]: 'typeBc',
};

const TYPE_DESCRIPTION_KEYS: Partial<Record<LegacyProductCode, string>> = {
  [LegacyProductCode.GO]: 'typeGoDescription',
  [LegacyProductCode.IG]: 'typeIgDescription',
  [LegacyProductCode.TT]: 'typeTtDescription',
  [LegacyProductCode.FB]: 'typeFbDescription',
  [LegacyProductCode.ME]: 'typeMeDescription',
  [LegacyProductCode.CU]: 'typeCuDescription',
  [LegacyProductCode.BC]: 'typeBcDescription',
};

export function ProductsSetupStepSelectType({
  includeBusinessCard,
  onSelect,
}: {
  includeBusinessCard: boolean;
  onSelect: (type: LegacyProductCode) => void;
}) {
  const dict = useDictionary();
  const setup = (dict as { products?: { setup?: Record<string, string> } })
    .products?.setup;
  const types = selectableSetupTypes(includeBusinessCard);

  return (
    <ProductsSetupStepShell
      title={setup?.selectTypeTitle ?? ''}
      description={setup?.selectTypeDescription}
    >
      <div className="grid grid-cols-1 gap-3 sm:gap-3.5 md:grid-cols-2 md:gap-4">
        {types.map((type) => {
          const label = setup?.[TYPE_LABEL_KEYS[type]] ?? type;
          const descriptionKey = TYPE_DESCRIPTION_KEYS[type];
          const description = descriptionKey
            ? setup?.[descriptionKey]
            : undefined;
          return (
            <ProductsSetupChoiceCard
              key={type}
              title={label}
              description={description}
              leading={
                <ProductTypeIcon
                  productType={type}
                  label={label}
                  className="size-4 shrink-0 sm:size-5"
                />
              }
              onClick={() => onSelect(type)}
            />
          );
        })}
      </div>
    </ProductsSetupStepShell>
  );
}
